'use client';

import { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface InstagramPost {
  id: string;
  image: string;
  alt: string;
  likes: number;
}

const instagramPosts: InstagramPost[] = [
{
  id: 'ig_1',
  image: "https://images.unsplash.com/photo-1596287452759-7c86e9afc617",
  alt: 'Newlyweds walking hand in hand through lavender field at golden hour',
  likes: 2847
},
{
  id: 'ig_2',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12e24bc4b-1767179828502.png",
  alt: 'Elegant wedding tablescape with white roses and gold candlesticks',
  likes: 1923
},
{
  id: 'ig_3',
  image: "https://images.unsplash.com/photo-1646336197410-2535e4f0f3a9",
  alt: 'Bride getting ready with bridesmaids in matching robes holding champagne',
  likes: 3156
},
{
  id: 'ig_4',
  image: "https://images.unsplash.com/photo-1714106980215-52465407e563",
  alt: 'Groom adjusting boutonniere with groomsmen laughing in background',
  likes: 1745
},
{
  id: 'ig_5',
  image: "https://images.unsplash.com/photo-1670529776180-60e4132ab90c",
  alt: 'Wedding ceremony outdoor aisle with white chairs and floral arch',
  likes: 2634
},
{
  id: 'ig_6',
  image: "https://images.unsplash.com/photo-1707192324808-badf097b0f32",
  alt: 'Wedding reception dance floor with guests celebrating under string lights',
  likes: 2891
}];


export default function InstagramFeed() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );

    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section data-component-id="src/app/homepage/components/InstagramFeed.tsx:75:4" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="75" data-component-end-line="117" data-component-file="InstagramFeed.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-20%20md%3Apy-32%20px-6%20md%3Apx-12%20max-w-container%20mx-auto%22%7D" ref={sectionRef} className="py-20 md:py-32 px-6 md:px-12 max-w-container mx-auto">
      <div data-component-id="src/app/homepage/components/InstagramFeed.tsx:76:6" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="76" data-component-end-line="92" data-component-file="InstagramFeed.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-12%20text-center%20reveal%22%7D" className="mb-12 text-center reveal">
        <h2 data-component-id="src/app/homepage/components/InstagramFeed.tsx:77:8" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="77" data-component-end-line="79" data-component-file="InstagramFeed.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-4xl%20md%3Atext-5xl%20font-serif%20font-semibold%20text-foreground%20mb-4%22%2C%22textContent%22%3A%22Follow%20Our%20Journey%22%7D" className="text-4xl md:text-5xl font-serif font-semibold text-foreground mb-4">
          Follow Our Journey
        </h2>
        <p data-component-id="src/app/homepage/components/InstagramFeed.tsx:80:8" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="80" data-component-end-line="82" data-component-file="InstagramFeed.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20text-muted-foreground%20mb-6%22%2C%22textContent%22%3A%22Daily%20inspiration%20and%20behind-the-scenes%20moments%20on%20Instagram%22%7D" className="text-lg text-muted-foreground mb-6">
          Daily inspiration and behind-the-scenes moments on Instagram
        </p>
        <a data-component-id="src/app/homepage/components/InstagramFeed.tsx:83:8" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="83" data-component-end-line="91" data-component-file="InstagramFeed.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Finstagram.com%2Facuilcreations%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-2%20text-primary%20hover%3Atext-primary%2F80%20transition-colors%20font-semibold%22%2C%22textContent%22%3A%22%40acuilcreations%22%7D"
          href="https://instagram.com/acuilcreations"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-semibold">

          <Icon data-component-id="src/app/homepage/components/InstagramFeed.tsx:89:10" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="89" data-component-end-line="89" data-component-file="InstagramFeed.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22CameraIcon%22%7D" name="CameraIcon" size={20} />
          @acuilcreations
        </a>
      </div>

      <div data-component-id="src/app/homepage/components/InstagramFeed.tsx:94:6" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="94" data-component-end-line="116" data-component-file="InstagramFeed.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-3%20gap-4%20reveal%20delay-100%22%7D" className="grid grid-cols-2 md:grid-cols-3 gap-4 reveal delay-100">
        {instagramPosts.map((post) =>
        <a data-component-id="src/app/homepage/components/InstagramFeed.tsx:96:8" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="96" data-component-end-line="114" data-component-file="InstagramFeed.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Finstagram.com%2Facuilcreations%22%2C%22className%22%3A%22relative%20group%20overflow-hidden%20rounded-2xl%20aspect-square%22%7D"
          key={post.id}
          href="https://instagram.com/acuilcreations"
          target="_blank"
          rel="noopener noreferrer"
          className="relative group overflow-hidden rounded-2xl aspect-square">

            <AppImage data-component-id="src/app/homepage/components/InstagramFeed.tsx:103:12" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="103" data-component-end-line="106" data-component-file="InstagramFeed.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20group-hover%3Ascale-105%20transition-transform%20duration-500%22%7D"
            src={post.image}
            alt={post.alt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

            <div data-component-id="src/app/homepage/components/InstagramFeed.tsx:108:12" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="108" data-component-end-line="113" data-component-file="InstagramFeed.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-black%2F60%20opacity-0%20group-hover%3Aopacity-100%20transition-opacity%20duration-300%20flex%20items-center%20justify-center%22%7D" className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <div data-component-id="src/app/homepage/components/InstagramFeed.tsx:109:14" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="109" data-component-end-line="112" data-component-file="InstagramFeed.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%20text-white%22%7D" className="flex items-center gap-2 text-white">
                <Icon data-component-id="src/app/homepage/components/InstagramFeed.tsx:110:16" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="110" data-component-end-line="110" data-component-file="InstagramFeed.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22HeartIcon%22%7D" name="HeartIcon" variant="solid" size={24} />
                <span data-component-id="src/app/homepage/components/InstagramFeed.tsx:111:16" data-component-path="src/app/homepage/components/InstagramFeed.tsx" data-component-line="111" data-component-end-line="111" data-component-file="InstagramFeed.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%22%7D" className="font-semibold">{post.likes.toLocaleString()}</span>
              </div>
            </div>
          </a>
        )}
      </div>
    </section>);

}